module.exports = __webpack_public_path__ + "img/file.e76b44a4.svg";